/**
 * Human-readable message from thrown values (network, Firebase, etc.).
 */
export function getErrorMessage(error: unknown): string {
  if (error !== null && error !== undefined && typeof error === 'object' && 'message' in error) {
    const m = (error as {message?: unknown}).message;
    if (typeof m === 'string' && m.length > 0) {
      return m;
    }
  }
  return 'An unknown error occurred';
}
